"use strict";

exports.__esModule = true;
exports.FormExample = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var Yup = _interopRequireWildcard(require("yup"));
var _TextInput = require("../TextInput/TextInput");
var _NumberInput = require("../NumberInput/NumberInput");
var _FormButton = require("../FormButton/FormButton");
var _SelectInput = require("../SelectInput/SelectInput");
var _CheckboxInput = require("../CheckboxInput/CheckboxInput");
var _CheckboxGroup = require("../CheckboxGroup/CheckboxGroup");
var _DateInput = require("../DateInput/DateInput");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable jsx-a11y/label-has-associated-control */

const DisplayFormikState = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
  style: {
    margin: '1rem 0'
  },
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    style: {
      fontFamily: 'monospace'
    }
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("pre", {
    style: {
      background: '#f6f8fa',
      fontSize: '.65rem',
      padding: '.5rem'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
      children: "props"
    }), " = ", JSON.stringify(props, null, 2)]
  })]
});
const FormExample = () => {
  const [hasSubmitted, setHasSubmitted] = (0, _react.useState)(false);
  const formik = (0, _formik.useFormik)({
    initialValues: {
      firstName: 'Peter',
      lastName: '',
      phone: '123',
      email: '',
      country: 'CA',
      agree: '',
      colors: ['red'],
      dob: ''
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required('First name is missing'),
      lastName: Yup.string().required('Last name is missing'),
      phone: Yup.number().required('Phone is missing'),
      email: Yup.string().email('Email is invalid').required('Email is missing'),
      country: Yup.string().required('Country is missing'),
      agree: Yup.bool().oneOf([true], 'Agree is missing'),
      colors: Yup.array().of(Yup.string()).required('Colors is missing')
    }),
    onSubmit: (values, {
      setSubmitting
    }) => {
      console.log('call api: ');
      console.log(JSON.stringify(values, null, 2));
      setTimeout(() => {
        setHasSubmitted(true);
        setSubmitting(false);
        setTimeout(() => {
          setHasSubmitted(false);
        }, 2000);
      }, 3000);
    }
  });
  let saveButtonText;
  let saveButtonProgress;
  if (formik.isSubmitting) {
    saveButtonText = '...Saving';
    saveButtonProgress = 2;
  } else if (hasSubmitted) {
    saveButtonText = 'Saved!';
    saveButtonProgress = 3;
  } else {
    saveButtonText = 'Save';
    saveButtonProgress = 1;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
    onSubmit: formik.handleSubmit,
    noValidate: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("fieldset", {
      disabled: formik.isSubmitting,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextInput.TextInput, {
        label: "First Name",
        name: "firstName",
        error: !!(formik.touched.firstName && formik.errors.firstName),
        errorMsg: formik.errors.firstName,
        disabled: false,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.firstName
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextInput.TextInput, {
        label: "Last Name",
        name: "lastName",
        error: !!(formik.touched.lastName && formik.errors.lastName),
        errorMsg: formik.errors.lastName,
        disabled: false,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.lastName
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NumberInput.NumberInput, {
        label: "Phone",
        name: "phone",
        error: !!(formik.touched.phone && formik.errors.phone),
        errorMsg: formik.errors.phone,
        disabled: false,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.phone,
        requiredLength: 10
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextInput.TextInput, {
        label: "Email",
        name: "email",
        error: !!(formik.touched.email && formik.errors.email),
        errorMsg: formik.errors.email,
        disabled: false,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.email
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectInput.SelectInput, {
        dataList: [{
          label: 'Australia',
          value: 'AU'
        }, {
          label: 'Canada',
          value: 'CA'
        }, {
          label: 'Germany',
          value: 'DE'
        }, {
          label: 'United States',
          value: 'US'
        }],
        flagIcon: true,
        error: !!(formik.touched.country && formik.errors.country),
        errorMsg: formik.errors.country,
        disabled: false,
        label: "Country",
        name: "country",
        promptText: "Select...",
        onChange: formik.setFieldValue,
        onBlur: formik.setFieldTouched,
        defaultValue: formik.values.country,
        isSearchable: true
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxInput.CheckboxInput, {
        label: "Agree",
        name: "agree",
        id: "agree",
        error: !!(formik.touched.agree && formik.errors.agree),
        errorMsg: formik.errors.agree,
        disabled: false,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.agree
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxGroup.CheckboxGroup, {
        fields: [{
          id: 'colors-blue',
          label: 'Blue',
          value: 'blue'
        }, {
          checked: true,
          id: 'colors-red',
          label: 'Red',
          value: 'red'
        }, {
          id: 'colors-green',
          label: 'Green',
          value: 'green'
        }],
        label: "Favourite colors",
        name: "colors",
        error: !!(formik.touched.colors && formik.errors.colors),
        errorMsg: formik.errors.colors,
        disabled: false,
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.colors
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateInput.DateInput, {
        fields: [{
          id: 'day',
          label: 'DD',
          maxLength: 2,
          name: 'day',
          pattern: '^[0-9]{2}$',
          size: 2
        }, {
          id: 'month',
          label: 'MM',
          maxLength: 2,
          name: 'month',
          pattern: '^[0-9]{2}$',
          size: 2
        }, {
          id: 'year',
          label: 'YYYY',
          maxLength: 4,
          name: 'year',
          pattern: '^[0-9]{4}$',
          size: 4
        }],
        hint: "Day, month, year, eg. 12 02 1982",
        inputMode: "numeric",
        label: "Date of birth",
        name: "dob",
        error: !!(formik.touched.dob && formik.errors.dob),
        errorMsg: formik.errors.dob,
        disabled: false
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormButton.FormButton, {
      disabled: !formik.isValid || !formik.dirty || formik.isSubmitting,
      onClick: () => {},
      text: saveButtonText,
      type: "save",
      progress: saveButtonProgress
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DisplayFormikState, {
      ...formik
    })]
  });
};
exports.FormExample = FormExample;